import { useIntl } from 'react-intl';
import css from './CustomKeyword.module.css';
import { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

const initialiseInput = () => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('keywords') || '';
  }
};

function CustomKeyword(props) {
  const intl = useIntl();
  const [input, setInput] = useState(initialiseInput);
  const history = useHistory();
  const inputRef = useRef(null);

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      history.push(`/s?keywords=${input}`);
      if (inputRef.current) {
        inputRef.current.blur(); // Close the mobile keyboard
      }
    }
  };

  return (
    <div className={css.root}>
      <input
        type="text"
        placeholder={intl.formatMessage({ id: 'TopbarSearchForm.placeholder' })}
        className={css.searchInput}
        value={input}
        ref={inputRef}
        onKeyDown={handleKeyDown}
        onChange={e => setInput(e.target.value)}
      />
    </div>
  );
}
export default CustomKeyword;
